export default __webpack_public_path__ + "static/media/Me.7ea77704.jpg";